module.exports = __webpack_public_path__ + "img/plan_logo_2.c6ee4102.png";